import { useAuth } from '../contexts/AuthContext';

/**
 * Returns the user's effective tier.
 *
 * Admin users always get "premium".  In v1 this simply reads
 * subscription_tier from the profile; future versions will incorporate
 * trial logic, grace periods, and payment-failure handling — all in
 * this one hook.
 *
 * @returns {"free" | "pro" | "premium"}
 */
export function useEffectiveTier() {
  const { profile } = useAuth();

  if (!profile) return 'free';
  if (profile.is_admin) return 'premium';

  const tier = profile.subscription_tier;
  if (tier === 'pro' || tier === 'premium') return tier;
  return 'free';
}
